/**
 * Multi-country phone normalization (client).
 * Supports: Jordan (+962), Saudi (+966), UAE (+971), Kuwait (+965),
 * Qatar (+974), Oman (+968), Bahrain (+973), Egypt (+20)
 */

const COUNTRY_PREFIXES: { code: string; pattern: RegExp; localLen: number }[] = [
  { code: '962', pattern: /^0?7\d{8}$/, localLen: 10 },  // Jordan
  { code: '966', pattern: /^0?5\d{8}$/, localLen: 10 },  // Saudi Arabia
  { code: '971', pattern: /^0?5\d{8}$/, localLen: 10 },  // UAE
  { code: '965', pattern: /^0?\d{8}$/, localLen: 8 },     // Kuwait
  { code: '974', pattern: /^0?\d{8}$/, localLen: 8 },     // Qatar
  { code: '968', pattern: /^0?\d{8}$/, localLen: 8 },     // Oman
  { code: '973', pattern: /^0?\d{8}$/, localLen: 8 },     // Bahrain
  { code: '20',  pattern: /^0?1[0-25-9]\d{8}$/, localLen: 11 }, // Egypt
];

export function normalizePhone(raw: string): string {
  if (!raw || typeof raw !== 'string') return '';

  let cleaned = raw.trim().replace(/\s/g, '').replace(/-/g, '');

  // Handle 00 prefix
  if (cleaned.startsWith('00')) {
    cleaned = '+' + cleaned.substring(2).replace(/[^\d+]/g, '');
  }

  // Already E.164
  if (cleaned.startsWith('+')) {
    const digits = cleaned.replace(/\D/g, '');
    if (digits.length >= 8) return '+' + digits;
    return cleaned;
  }

  const digits = cleaned.replace(/\D/g, '');
  if (!digits) return '';

  // Try matching local formats
  for (const { code, pattern, localLen } of COUNTRY_PREFIXES) {
    if (pattern.test(digits)) {
      const withoutZero = digits.replace(/^0/, '');
      return `+${code}${withoutZero}`;
    }
  }

  // Check if it starts with a known country code already
  for (const { code } of COUNTRY_PREFIXES) {
    if (digits.startsWith(code)) {
      return `+${digits}`;
    }
  }

  // Fallback
  return `+${digits}`;
}